import { Injectable } from '@angular/core'

import { Overview } from '../_models/overview.model'

import { environment } from '../../../environments/environment';


// overviewHelper.pathFromName(component['name'])

@Injectable()
export class OverviewHelper {

  private prefix:string = 'mat-'

  private static overviewsData: any = [
    { name: 'upcoming',
    },

    { name: 'animation',
      urls: [ 'https://developer.mozilla.org/en-US/docs/Web/API/Web_Animations_API/Using_the_Web_Animations_API' ]
    },

    { name: 'audio',
      urls: [] },

    { name: 'autocomplete',
      material: true },

    { name: 'badge',
      material: true },
      
    { name: 'breadcrumbs' },

    // REMOVED; SCREWS UP FORMATTING SOMEHOW... 
    // { name: 'book',
    //   urls: ['https://medium.com/undefined-methods/flipping-pages-with-css-ea7f8160745a',
    //          'https://3dbookcovergenerator.netlify.app/'] },

    { name: 'bottom-sheet',
      material: true },

    { name: 'button',
      material: true },

    { name: 'button-toggle',
      material: true },

    { name: 'card',
      material: true },

    { name: 'carousel',
      urls: [ 'https://stackoverflow.com/questions/70442770/infinite-scrolling-carousel-css-only',
              'https://github.com/angular/material.angular.io/tree/main/src/app/shared/carousel'  ] },

    { name: 'checkbox',
      material: true },

    { name: 'chip',
      material: true },

    { name: 'contentful',
      urls: [ `https://app.contentful.com/spaces/${ environment.contentful.spaceId }/entries` ] },

    { name: 'datepicker',
      material: true },

    { name: 'dialog',
      material: true },

    { name: 'divider',
      material: true },

    { name: 'drag-drop',
      urls: [ 'https://material.angular.io/cdk/drag-drop/' ] },

    { name: 'email' },

    { name: 'expansion-panel',
      material: true,
      material_link: 'expansion' },

    { name: 'form',
      urls: ['https://material.angular.io/components/form-field/overview'] },

    { name: 'icon',
      material: true,
      urls: ['https://fonts.google.com/icons?icon.set=Material+Icons',
             'https://fonts.google.com/icons?icon.set=Material+Symbols'] },

    { name: 'list',
      material: true },

    { name: 'menu',
      material: true },

    { name: 'paginator',
      material: true },

    { name: 'parallax',
      urls: [ 'https://alvarotrigo.com/blog/how-to-create-a-parallax-effect-with-css-only/',
              'https://codepen.io/yagoestevez/pen/EdgRMX',
              'https://www.youtube.com/watch?v=mxHoPYFsTuk&ab_channel=WebDevSimplified' ] },
    
    {  name: 'payment' },

    { name: 'progress-bar',
      material: true },

    { name: 'progress-spinner',
      material: true },

    { name: 'ripples',
      material: true,
      material_link: 'ripple' },

    { name: 'sidenav',
      material: true },

    { name: 'slide-toggle',
      material: true },

    { name: 'slider',
      material: true },

    { name: 'sticky',
      urls: [ 'https://developer.mozilla.org/en-US/docs/Web/CSS/position' ] },

    { name: 'snackbar',
      material: true,
      material_link: 'snack-bar' },

    { name: 'stepper',
      material: true },

    { name: 'table',
      material: true,
      urls: [
        'https://material.angular.io/components/sort/overview',
        'https://material.angular.io/components/table/overview'
      ] },

    { name: 'tabs',
      material: true },

    { name: 'table-of-contents',
      urls: [ 'https://github.com/angular/material.angular.io/tree/main/src/app/shared/table-of-contents'] }, // 'https://github.com/angular/angular/tree/main/aio/src/app/custom-elements/toc' ] },

    { name: 'toolbar',
      material: true },

    { name: 'video' },



  ]

  public overviews(): Overview[] {
    return OverviewHelper.overviewsData.map( (data: any) => {
      return new Overview(data)
    })
  }

  public getOverview(name: any) {
    let all = this.overviews().filter(function (overview) { 
      return overview.name === name
    });
    return all && all[0]
  }

  public pathFromName(name: string) {
    return this.prefix + name
  }

  public overviewIsActive(overview: Overview, path: any): boolean {
    // let isActive = fragment === overview.fragment()
    let isActive = overview.path() === path
    // console.log('active?', isActive, overview.name, path)
    return isActive
  }

  // public snakeCaseFromString(str: string) {
  //   if (!str) return
  //   return str.match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g)
  //             .map(x => x.toLowerCase())
  //             .join('_');
  // }

}
